import { Box, Button, Grid, Tooltip } from "@mui/material";
import { BillingStepper } from "../../../../../Base/components/Stepper";
import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export interface CorrectionHeaderActionsProps {
  activeStep: number;
  onAddRx: () => void;
  onFilterValid: () => void;
  onSaveBills: () => void;
  tableVisible: boolean;
}

export function CorrectionHeaderActions({
  activeStep,
  onAddRx,
  onFilterValid,
  onSaveBills,
  tableVisible,
}: CorrectionHeaderActionsProps) {
  return (
    <Box
      sx={{
        padding: 1,
      }}
    >
      {/* Pass custom steps for correction billing */}
      <BillingStepper
        activeStep={activeStep}
        isPaperBilling={true} // Use the 3-step process instead of 4-step
      />
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={0}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onAddRx}
            sx={{ borderRadius: 2 }}
          >
            Transaktion suchen
          </Button>
        </Grid>

        {tableVisible && (
          <>
            <Grid item xs={0}>
              <Tooltip title="Korrekturen Erstellen" arrow>
                <Button
                  variant="contained"
                  endIcon={<ArrowForwardIcon />}
                  onClick={onSaveBills}
                  sx={{
                    borderRadius: 2,
                    backgroundColor: "success.main",
                    "&:hover": {
                      backgroundColor: "success.main",
                    },
                  }}
                >
                  Weiter
                </Button>
              </Tooltip>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
}
